'use strict';

var _regeneratorRuntime = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/inherits");

var path = require('path');

var EventEmitter = require('events');

var PROTOCOL = require('./protocol');

var encode = require('./encoding');

var waitForPeers = require('./wait-for-peers');

var getPeerID = require('./get-peer-id');
/**
 * Communication channel over Pubsub between two IPFS nodes
 */


var DirectChannel =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(DirectChannel, _EventEmitter);

  function DirectChannel(ipfs, receiverID) {
    var _this;

    _classCallCheck(this, DirectChannel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DirectChannel).call(this)); // IPFS instance to use internally

    _this._ipfs = ipfs;

    if (!ipfs.pubsub) {
      throw new Error('This IPFS node does not support pubsub.');
    }

    _this._receiverID = receiverID;

    if (!_this._receiverID) {
      throw new Error('Receiver ID was undefined');
    } // See _setup() for more state initialization


    return _this;
  }
  /**
   * Channel ID
   * @return {[String]} Channel's ID
   */


  _createClass(DirectChannel, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return waitForPeers(this._ipfs, [this._receiverID], this._id);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function connect() {
        return _connect.apply(this, arguments);
      };
    }()
    /**
     * Send a message to the other peer
     * @param  {[Any]} message Payload
     */

  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(message) {
        var m;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                m = encode(message);
                _context2.next = 3;
                return this._ipfs.pubsub.publish(this._id, m);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function send(_x) {
        return _send.apply(this, arguments);
      };
    }()
    /**
     * Close the channel
     */

  }, {
    key: "close",
    value: function close() {
      this.removeAllListeners('message');

      this._ipfs.pubsub.unsubscribe(this._id, this._messageHandler);
    }
  }, {
    key: "_setup",
    value: function () {
      var _setup2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getPeerID(this._ipfs);

              case 2:
                this._senderID = _context3.sent;
                // Channel's participants
                this._peers = Array.from([this._senderID, this._receiverID]).sort(); // ID of the channel is "<peer1 id>/<peer 2 id>""

                this._id = path.join('/', PROTOCOL, this._peers.join('/')); // Function to use to handle incoming messages

                this._messageHandler = function (message) {
                  // Make sure the message is coming from the correct peer
                  var isValid = message && message.from === _this2._receiverID; // Filter out all messages that didn't come from the second peer

                  if (isValid) {
                    _this2.emit('message', message);
                  }
                };

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      return function _setup() {
        return _setup2.apply(this, arguments);
      };
    }()
  }, {
    key: "_openChannel",
    value: function () {
      var _openChannel2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._setup();

              case 2:
                _context4.next = 4;
                return this._ipfs.pubsub.subscribe(this._id, this._messageHandler);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      return function _openChannel() {
        return _openChannel2.apply(this, arguments);
      };
    }()
  }, {
    key: "id",
    get: function get() {
      return this._id;
    }
    /**
     * Peers participating in this channel
     * @return {[Array]} Array of peer IDs participating in this channel
     */

  }, {
    key: "peers",
    get: function get() {
      return this._peers;
    }
  }], [{
    key: "open",
    value: function () {
      var _open = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(ipfs, receiverID) {
        var channel;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                channel = new DirectChannel(ipfs, receiverID);
                _context5.next = 3;
                return channel._openChannel();

              case 3:
                return _context5.abrupt("return", channel);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      return function open(_x2, _x3) {
        return _open.apply(this, arguments);
      };
    }()
  }]);

  return DirectChannel;
}(EventEmitter);

module.exports = DirectChannel;